<template>  
    <section class="block block--skillslist">
        <div class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 text-right skillslist__text">
                    <h2 v-if="block.title">{{ block.title }}</h2>
                    <div v-if="block.subtitle" class="subtitle">{{ block.subtitle }}</div>
                    <div v-if="block.description" v-html="block.description" class="mb-2 mb-md-0"></div>
                </div>
                <div class="col-md-6 skillslist__skills">
                    <div
                        v-for="(skill, index) in block.skills"
                        :key="index"
                        class="skill w-100 mb-1 d-flex justify-content-between">
                        <div class="skill__title">
                            {{ skill.name }}
                        </div>
                        <div class="skill__bar">
                            <div class="skill__bar--active"
                                :style="`width: ${skill.level}%;`">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </section>
</template>

<script>

export default { 
    name: 'skillslist',

    props: {
        block: {
            type: Object,
            default: () => {}
        }
    }
}
</script>